export const stageType = {
    betting: 'betting',
    waiting: 'waiting',
    rolling: 'rolling',
    finished: 'finished',
}
